"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var json_api_fetch_1 = require("./json_api_fetch");
/**
 * @param reactionQuery [ReactionsFetchQuery] available queries:
 *                    - wallId [number] id of the wall
 */


function fetchReactions(reactionQuery) {
  var query = {
    wall_id: reactionQuery.wallId.toString()
  };

  if (reactionQuery.pageStart) {
    query.page_start = reactionQuery.pageStart;
  }

  return (0, json_api_fetch_1.jsonApiFetch)('reactions', {
    query: query
  });
}

exports.default = fetchReactions;